var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "checkout__body",
      class: { loading: _vm.loading },
      attrs: { id: "hide_header_footer" },
    },
    [
      !_vm.isLoggedIn
        ? _c("div", { staticClass: "navigator" }, [
            _c(
              "div",
              {
                staticClass: "navigator__item",
                class: { active: _vm.selectedPage == 0 },
                on: {
                  click: () => {
                    _vm.selectPage(0)
                  },
                },
              },
              [_c("span", [_vm._v("Ik ben een nieuwe klant")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "navigator__item",
                class: { active: _vm.selectedPage == 1 },
                on: {
                  click: () => {
                    _vm.selectPage(1)
                  },
                },
              },
              [_c("span", [_vm._v("Ik ben een bestaande klant")])]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout__body__block" },
        [
          _c("Transition", { attrs: { mode: "out-in", name: "view" } }, [
            _vm.selectedPage == 0 && !_vm.isLoggedIn
              ? _c(
                  "div",
                  { staticClass: "page-wrapper" },
                  [
                    _c("div", { staticClass: "form-section" }, [
                      _c("h3", [_vm._v("Je gegevens")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("input-block", {
                            attrs: {
                              label: "Voornaam",
                              name: "firstName",
                              error: _vm.guestErrors.first_name,
                              required: true,
                            },
                            model: {
                              value: _vm.guestForm.first_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.guestForm, "first_name", $$v)
                              },
                              expression: "guestForm.first_name",
                            },
                          }),
                          _vm._v(" "),
                          _c("input-block", {
                            attrs: {
                              label: "Achternaam",
                              name: "lastName",
                              error: _vm.guestErrors.last_name,
                              required: true,
                            },
                            model: {
                              value: _vm.guestForm.last_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.guestForm, "last_name", $$v)
                              },
                              expression: "guestForm.last_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("input-block", {
                            attrs: {
                              label: "E-mailadres",
                              type: "email",
                              name: "email",
                              error: _vm.guestErrors.email,
                              required: true,
                            },
                            model: {
                              value: _vm.guestForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.guestForm, "email", $$v)
                              },
                              expression: "guestForm.email",
                            },
                          }),
                          _vm._v(" "),
                          _c("input-block", {
                            attrs: {
                              label: "Telefoonnummer",
                              name: "phone",
                              type: "tel",
                              error: _vm.guestErrors.phone,
                              required: true,
                            },
                            model: {
                              value: _vm.guestForm.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.guestForm, "phone", $$v)
                              },
                              expression: "guestForm.phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("input-block", {
                            staticClass: "w-100",
                            attrs: {
                              label: "Factuur e-mailadres",
                              name: "invoice_email",
                              type: "email",
                              error: _vm.guestErrors.billing_email,
                            },
                            model: {
                              value: _vm.guestForm.billing_email,
                              callback: function ($$v) {
                                _vm.$set(_vm.guestForm, "billing_email", $$v)
                              },
                              expression: "guestForm.billing_email",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-section" }, [
                      _c(
                        "div",
                        { staticClass: "toggle-input" },
                        [
                          _c("ToggleButton", {
                            on: {
                              checked: (state) => {
                                _vm.isCompany = state
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ik ben een zakelijke klant")]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "Transition",
                      { attrs: { mode: "out-in", name: "view" } },
                      [
                        _vm.isCompany
                          ? _c(
                              "div",
                              {
                                staticClass: "form-section",
                                attrs: { id: "company" },
                              },
                              [
                                _c("h3", [_vm._v("Bedrijfsgegevens")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c("input-block", {
                                      attrs: {
                                        label: "Bedrijfsnaam",
                                        error: _vm.guestErrors.billing_company,
                                        required: true,
                                        name: "companyName",
                                      },
                                      model: {
                                        value: _vm.guestForm.billing_company,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.guestForm,
                                            "billing_company",
                                            $$v
                                          )
                                        },
                                        expression: "guestForm.billing_company",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input-block", {
                                      attrs: {
                                        label: "Referentienummer",
                                        name: "refNumber",
                                      },
                                      model: {
                                        value:
                                          _vm.guestForm
                                            .billing_reference_number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.guestForm,
                                            "billing_reference_number",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "guestForm.billing_reference_number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c("input-block", {
                                      attrs: {
                                        label: "KvK Nummer",
                                        required: true,
                                        error:
                                          _vm.guestErrors
                                            .billing_chamber_of_commerce_number,
                                        name: "kvk",
                                      },
                                      model: {
                                        value:
                                          _vm.guestForm
                                            .billing_chamber_of_commerce_number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.guestForm,
                                            "billing_chamber_of_commerce_number",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "guestForm.billing_chamber_of_commerce_number",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input-block", {
                                      attrs: {
                                        label: "BTW Nummer",
                                        error:
                                          _vm.guestErrors.billing_vat_number,
                                        name: "tax",
                                      },
                                      on: { input: _vm.checkVatNumber },
                                      model: {
                                        value: _vm.guestForm.billing_vat_number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.guestForm,
                                            "billing_vat_number",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "guestForm.billing_vat_number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-section",
                        staticStyle: { "margin-top": "-30px" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row row-address" },
                          [
                            _c("input-block", {
                              staticClass: "w-30",
                              attrs: {
                                label: "Straat en huisnummer",
                                error: _vm.guestErrors.address_1,
                                required: true,
                                name: "street",
                              },
                              model: {
                                value: _vm.guestForm.address_1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.guestForm, "address_1", $$v)
                                },
                                expression: "guestForm.address_1",
                              },
                            }),
                            _vm._v(" "),
                            _c("input-block", {
                              staticClass: "w-25",
                              attrs: {
                                label: "Postcode",
                                error: _vm.guestErrors.postcode,
                                required: true,
                                name: "postcode",
                              },
                              model: {
                                value: _vm.guestForm.postcode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.guestForm, "postcode", $$v)
                                },
                                expression: "guestForm.postcode",
                              },
                            }),
                            _vm._v(" "),
                            _c("input-block", {
                              staticClass: "w-30",
                              attrs: {
                                label: "Plaats",
                                error: _vm.guestErrors.city,
                                required: true,
                                name: "city",
                              },
                              model: {
                                value: _vm.guestForm.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.guestForm, "city", $$v)
                                },
                                expression: "guestForm.city",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-section" }, [
                      _c(
                        "div",
                        { staticClass: "toggle-input" },
                        [
                          _c("ToggleButton", {
                            attrs: { defaultChecked: false },
                            on: {
                              checked: (state) => {
                                _vm.isAccount = state
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ik wil een account aanmaken")]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "Transition",
                      { attrs: { mode: "out-in", name: "view" } },
                      [
                        _vm.isAccount
                          ? _c(
                              "div",
                              {
                                staticClass: "form-section",
                                attrs: { id: "account" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c("input-block", {
                                      attrs: {
                                        label: "Wachtwoord",
                                        error: _vm.guestErrors.password,
                                        "error-message":
                                          !_vm.guestFormPasswordMatch
                                            ? "De wachtwoorden komen niet overeen"
                                            : "",
                                        required: true,
                                        type: "password",
                                        name: "password",
                                      },
                                      model: {
                                        value: _vm.guestForm.password,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.guestForm,
                                            "password",
                                            $$v
                                          )
                                        },
                                        expression: "guestForm.password",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("input-block", {
                                      attrs: {
                                        label: "Wachtwoord herhalen",
                                        error: _vm.guestErrors.password_repeat,
                                        required: true,
                                        type: "password",
                                        name: "passwordRepeat",
                                      },
                                      model: {
                                        value: _vm.guestForm.password_repeat,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.guestForm,
                                            "password_repeat",
                                            $$v
                                          )
                                        },
                                        expression: "guestForm.password_repeat",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "controls__wrapper" }, [
                      _c(
                        "div",
                        {
                          staticClass: "previous-button",
                          on: { click: _vm.prevPage },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "24",
                                height: "25",
                                viewBox: "0 0 24 25",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10.7335 20.29C10.8785 20.4213 11.0691 20.4907 11.2646 20.4834C11.4601 20.4761 11.645 20.3927 11.7799 20.2511C11.9148 20.1094 11.989 19.9206 11.9866 19.725C11.9843 19.5294 11.9057 19.3425 11.7675 19.204L5.51648 13.25H20.2505C20.4494 13.25 20.6402 13.171 20.7808 13.0303C20.9215 12.8897 21.0005 12.6989 21.0005 12.5C21.0005 12.3011 20.9215 12.1103 20.7808 11.9697C20.6402 11.829 20.4494 11.75 20.2505 11.75H5.51648L11.7675 5.79502C11.9057 5.65658 11.9843 5.46962 11.9866 5.27402C11.989 5.07841 11.9148 4.88964 11.7799 4.74797C11.645 4.6063 11.4601 4.52293 11.2646 4.51566C11.0691 4.50838 10.8785 4.57777 10.7335 4.70902L3.31348 11.776C3.15108 11.9301 3.04539 12.1344 3.01348 12.356C2.99518 12.4515 2.99552 12.5497 3.01448 12.645C3.0466 12.8662 3.15228 13.0702 3.31448 13.224L10.7335 20.29Z",
                                  fill: "#21386E",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Vorige stap")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "checkout__primary-button",
                          on: { click: _vm.validateGuest },
                        },
                        [
                          _c("span", [_vm._v("Volgende stap")]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              attrs: {
                                fill: "none",
                                height: "13",
                                viewBox: "0 0 9 13",
                                width: "9",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M0.357846 12.3798C0.454056 12.4298 0.562077 12.4527 0.670315 12.446C0.778554 12.4393 0.882922 12.4032 0.972219 12.3417L8.70392 6.989C8.78292 6.93426 8.84748 6.86119 8.89208 6.77605C8.93667 6.69091 8.95996 6.59623 8.95996 6.50012C8.95996 6.404 8.93667 6.30932 8.89208 6.22418C8.84748 6.13904 8.78292 6.06597 8.70392 6.01123L0.972219 0.658521C0.882991 0.596782 0.778575 0.560628 0.670274 0.553976C0.561974 0.547323 0.453918 0.570424 0.357805 0.620778C0.261691 0.671131 0.181185 0.746819 0.125001 0.839645C0.0688181 0.93247 0.0390991 1.0389 0.0390625 1.1474V11.8528C0.0390446 11.9614 0.0687421 12.0679 0.124936 12.1608C0.18113 12.2537 0.261677 12.3294 0.357846 12.3798Z",
                                  fill: "white",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedPage == 1 && !_vm.isLoggedIn
              ? _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "form-section" },
                    [
                      _c("h3", { attrs: { id: "login-label" } }, [
                        _vm._v("Inloggen"),
                      ]),
                      _vm._v(" "),
                      _c("input-block", {
                        staticClass: "w-100",
                        attrs: {
                          label: "E-mailadres",
                          name: "email",
                          type: "email",
                        },
                        model: {
                          value: _vm.loginForm.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "email", $$v)
                          },
                          expression: "loginForm.email",
                        },
                      }),
                      _vm._v(" "),
                      _c("input-block", {
                        staticClass: "w-100",
                        attrs: {
                          label: "Wachtwoord",
                          name: "password",
                          type: "password",
                          "error-message":
                            "Uw e-mailadres en/of wachtwoord is incorrect!",
                          error: _vm.accountErrors.login,
                        },
                        model: {
                          value: _vm.loginForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "password", $$v)
                          },
                          expression: "loginForm.password",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "forgot-password" }, [
                        _c("a", {
                          attrs: {
                            href: "/mijn-account/wachtwoord-vergeten/",
                            target: "_blank",
                          },
                          domProps: {
                            textContent: _vm._s("Wachtwoord vergeten?"),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "controls__wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "previous-button",
                        on: { click: _vm.prevPage },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "25",
                              viewBox: "0 0 24 25",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M10.7335 20.29C10.8785 20.4213 11.0691 20.4907 11.2646 20.4834C11.4601 20.4761 11.645 20.3927 11.7799 20.2511C11.9148 20.1094 11.989 19.9206 11.9866 19.725C11.9843 19.5294 11.9057 19.3425 11.7675 19.204L5.51648 13.25H20.2505C20.4494 13.25 20.6402 13.171 20.7808 13.0303C20.9215 12.8897 21.0005 12.6989 21.0005 12.5C21.0005 12.3011 20.9215 12.1103 20.7808 11.9697C20.6402 11.829 20.4494 11.75 20.2505 11.75H5.51648L11.7675 5.79502C11.9057 5.65658 11.9843 5.46962 11.9866 5.27402C11.989 5.07841 11.9148 4.88964 11.7799 4.74797C11.645 4.6063 11.4601 4.52293 11.2646 4.51566C11.0691 4.50838 10.8785 4.57777 10.7335 4.70902L3.31348 11.776C3.15108 11.9301 3.04539 12.1344 3.01348 12.356C2.99518 12.4515 2.99552 12.5497 3.01448 12.645C3.0466 12.8662 3.15228 13.0702 3.31448 13.224L10.7335 20.29Z",
                                fill: "#21386E",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Vorige stap")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "checkout__primary-button",
                        on: { click: _vm.handleLogin },
                      },
                      [
                        _c("span", [_vm._v("Inloggen")]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              fill: "none",
                              height: "13",
                              viewBox: "0 0 9 13",
                              width: "9",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M0.357846 12.3798C0.454056 12.4298 0.562077 12.4527 0.670315 12.446C0.778554 12.4393 0.882922 12.4032 0.972219 12.3417L8.70392 6.989C8.78292 6.93426 8.84748 6.86119 8.89208 6.77605C8.93667 6.69091 8.95996 6.59623 8.95996 6.50012C8.95996 6.404 8.93667 6.30932 8.89208 6.22418C8.84748 6.13904 8.78292 6.06597 8.70392 6.01123L0.972219 0.658521C0.882991 0.596782 0.778575 0.560628 0.670274 0.553976C0.561974 0.547323 0.453918 0.570424 0.357805 0.620778C0.261691 0.671131 0.181185 0.746819 0.125001 0.839645C0.0688181 0.93247 0.0390991 1.0389 0.0390625 1.1474V11.8528C0.0390446 11.9614 0.0687421 12.0679 0.124936 12.1608C0.18113 12.2537 0.261677 12.3294 0.357846 12.3798Z",
                                fill: "white",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoggedIn
              ? _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-section",
                      attrs: { id: "login-header" },
                    },
                    [
                      _c("h3", { attrs: { id: "login-label" } }, [
                        _vm._v("Vul je gegevens in"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Controleer of je gegevens nog kloppen en pas aan waar nodig."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Je bent ingelogd als " +
                            _vm._s(_vm.accountForm.first_name) +
                            " " +
                            _vm._s(_vm.accountForm.last_name) +
                            ".\n            "
                        ),
                        _c(
                          "a",
                          {
                            attrs: { id: "logout-tag" },
                            on: { click: _vm.handleLogout },
                          },
                          [_vm._v("Uitloggen?")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-section" }, [
                    _c("h3", [_vm._v("Persoonlijke gegevens")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("input-block", {
                          attrs: {
                            label: "Voornaam",
                            name: "firstName",
                            error: _vm.accountErrors.first_name,
                            required: true,
                          },
                          model: {
                            value: _vm.accountForm.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.accountForm, "first_name", $$v)
                            },
                            expression: "accountForm.first_name",
                          },
                        }),
                        _vm._v(" "),
                        _c("input-block", {
                          attrs: {
                            label: "Achternaam",
                            name: "lastName",
                            error: _vm.accountErrors.last_name,
                            required: true,
                          },
                          model: {
                            value: _vm.accountForm.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.accountForm, "last_name", $$v)
                            },
                            expression: "accountForm.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("input-block", {
                          attrs: {
                            label: "E-mailadres",
                            type: "email",
                            name: "email",
                            readonly: "",
                            error: _vm.accountErrors.email,
                            required: true,
                          },
                          model: {
                            value: _vm.accountForm.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.accountForm, "email", $$v)
                            },
                            expression: "accountForm.email",
                          },
                        }),
                        _vm._v(" "),
                        _c("input-block", {
                          attrs: {
                            label: "Telefoonnummer",
                            name: "phone",
                            error: _vm.accountErrors.phone,
                            type: "tel",
                            required: true,
                          },
                          model: {
                            value: _vm.accountForm.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.accountForm, "phone", $$v)
                            },
                            expression: "accountForm.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("input-block", {
                          staticClass: "w-100",
                          attrs: {
                            label: "Factuur e-mailadres",
                            name: "invoice_email",
                            type: "email",
                            error: _vm.accountErrors.billing_email,
                          },
                          model: {
                            value: _vm.accountForm.billing_email,
                            callback: function ($$v) {
                              _vm.$set(_vm.accountForm, "billing_email", $$v)
                            },
                            expression: "accountForm.billing_email",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.accountForm.is_company
                    ? _c(
                        "div",
                        {
                          staticClass: "form-section",
                          attrs: { id: "company" },
                        },
                        [
                          _c("h3", [_vm._v("Bedrijfsgegevens")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("input-block", {
                                attrs: {
                                  label: "Bedrijfsnaam",
                                  error: _vm.accountErrors.billing_company,
                                  required: true,
                                  name: "companyName",
                                },
                                model: {
                                  value: _vm.accountForm.billing_company,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.accountForm,
                                      "billing_company",
                                      $$v
                                    )
                                  },
                                  expression: "accountForm.billing_company",
                                },
                              }),
                              _vm._v(" "),
                              _c("input-block", {
                                attrs: {
                                  label: "Referentienummer",
                                  name: "refNumber",
                                },
                                model: {
                                  value:
                                    _vm.accountForm.billing_reference_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.accountForm,
                                      "billing_reference_number",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "accountForm.billing_reference_number",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("input-block", {
                                attrs: {
                                  label: "KvK Nummer",
                                  required: true,
                                  error:
                                    _vm.accountErrors
                                      .billing_chamber_of_commerce_number,
                                  name: "kvk",
                                },
                                model: {
                                  value:
                                    _vm.accountForm
                                      .billing_chamber_of_commerce_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.accountForm,
                                      "billing_chamber_of_commerce_number",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "accountForm.billing_chamber_of_commerce_number",
                                },
                              }),
                              _vm._v(" "),
                              _c("input-block", {
                                attrs: {
                                  label: "BTW Nummer",
                                  error: _vm.accountErrors.billing_vat_number,
                                  name: "tax",
                                },
                                on: { input: _vm.checkVatNumber },
                                model: {
                                  value: _vm.accountForm.billing_vat_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.accountForm,
                                      "billing_vat_number",
                                      $$v
                                    )
                                  },
                                  expression: "accountForm.billing_vat_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-section",
                      staticStyle: { "margin-top": "-30px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row row-address" },
                        [
                          _c("input-block", {
                            staticClass: "w-30",
                            attrs: {
                              label: "Straat en huisnummer",
                              error: _vm.accountErrors.address_1,
                              required: true,
                              name: "street",
                            },
                            model: {
                              value: _vm.accountForm.address_1,
                              callback: function ($$v) {
                                _vm.$set(_vm.accountForm, "address_1", $$v)
                              },
                              expression: "accountForm.address_1",
                            },
                          }),
                          _vm._v(" "),
                          _c("input-block", {
                            staticClass: "w-25",
                            attrs: {
                              label: "Postcode",
                              error: _vm.accountErrors.postcode,
                              required: true,
                              name: "postcode",
                            },
                            model: {
                              value: _vm.accountForm.postcode,
                              callback: function ($$v) {
                                _vm.$set(_vm.accountForm, "postcode", $$v)
                              },
                              expression: "accountForm.postcode",
                            },
                          }),
                          _vm._v(" "),
                          _c("input-block", {
                            staticClass: "w-30",
                            attrs: {
                              label: "Plaats",
                              error: _vm.accountErrors.city,
                              required: true,
                              name: "city",
                            },
                            model: {
                              value: _vm.accountForm.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.accountForm, "city", $$v)
                              },
                              expression: "accountForm.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "controls__wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "previous-button",
                        on: { click: _vm.prevPage },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "25",
                              viewBox: "0 0 24 25",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M10.7335 20.29C10.8785 20.4213 11.0691 20.4907 11.2646 20.4834C11.4601 20.4761 11.645 20.3927 11.7799 20.2511C11.9148 20.1094 11.989 19.9206 11.9866 19.725C11.9843 19.5294 11.9057 19.3425 11.7675 19.204L5.51648 13.25H20.2505C20.4494 13.25 20.6402 13.171 20.7808 13.0303C20.9215 12.8897 21.0005 12.6989 21.0005 12.5C21.0005 12.3011 20.9215 12.1103 20.7808 11.9697C20.6402 11.829 20.4494 11.75 20.2505 11.75H5.51648L11.7675 5.79502C11.9057 5.65658 11.9843 5.46962 11.9866 5.27402C11.989 5.07841 11.9148 4.88964 11.7799 4.74797C11.645 4.6063 11.4601 4.52293 11.2646 4.51566C11.0691 4.50838 10.8785 4.57777 10.7335 4.70902L3.31348 11.776C3.15108 11.9301 3.04539 12.1344 3.01348 12.356C2.99518 12.4515 2.99552 12.5497 3.01448 12.645C3.0466 12.8662 3.15228 13.0702 3.31448 13.224L10.7335 20.29Z",
                                fill: "#21386E",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Vorige stap")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "checkout__primary-button",
                        on: { click: _vm.validateAccount },
                      },
                      [
                        _c("span", [_vm._v("Volgende stap")]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              fill: "none",
                              height: "13",
                              viewBox: "0 0 9 13",
                              width: "9",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M0.357846 12.3798C0.454056 12.4298 0.562077 12.4527 0.670315 12.446C0.778554 12.4393 0.882922 12.4032 0.972219 12.3417L8.70392 6.989C8.78292 6.93426 8.84748 6.86119 8.89208 6.77605C8.93667 6.69091 8.95996 6.59623 8.95996 6.50012C8.95996 6.404 8.93667 6.30932 8.89208 6.22418C8.84748 6.13904 8.78292 6.06597 8.70392 6.01123L0.972219 0.658521C0.882991 0.596782 0.778575 0.560628 0.670274 0.553976C0.561974 0.547323 0.453918 0.570424 0.357805 0.620778C0.261691 0.671131 0.181185 0.746819 0.125001 0.839645C0.0688181 0.93247 0.0390991 1.0389 0.0390625 1.1474V11.8528C0.0390446 11.9614 0.0687421 12.0679 0.124936 12.1608C0.18113 12.2537 0.261677 12.3294 0.357846 12.3798Z",
                                fill: "white",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Views/CustomerInformationView.vue